import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import chatIcon from "./../../images/chat-icon.png";
import { useProductsContext } from "../../Contexts/SidebarContext";

const SelIcon = () => {
  const { subscriber, optinFollow } = useProductsContext();
  const selectedConnection: any = localStorage.getItem("selectedConnection");
  const subscriberOrOptin =
    subscriber === "subscriber" || optinFollow === "optin";
  const getIcon = () => {
    if (subscriberOrOptin) {
      return <img alt="" src={chatIcon} width={23} height={23} />;
    }
    if (selectedConnection === "nav-inst-tab") {
      return (
        <InstagramIcon
          sx={{ width: "32px", height: "32px" }}
          color="secondary"
        />
      );
    }
    return <img alt="" src={chatIcon} width={23} height={23} />;
  };

  return getIcon();
};

export default SelIcon;
